var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-table',_vm._b({attrs:{"headers":_vm.headers,"items":_vm.items,"item-key":"id"}},'base-table',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }